export default __webpack_public_path__ + "static/evening-80b8565076d914a531976acd98e88960.webp";